module.exports = __webpack_public_path__ + "media/images/icons/vendors/bachelorparty-96aede38453d2d6529bc3b5eee9e9686.png";